export default __webpack_public_path__ + "media/zurb/img/events/wired/dst/dst-image3-affb0412c0a0469f633912ddc8cfd60d.jpg";